<template lang="pug">
  v-layout(justify-center)
    v-flex(xs12)
      v-layout(justify-start)
        h2(class="card__title") {{$t('common.btnDraft')}}
      v-data-table(
        :headers="headers",
        :items="drafts",
        :loading="loading",
        :no-data-text="$t('common.noSumbitReport')",
        :rows-per-page-text="$t('ReportingPage.PaginationBlock.rowPage')",
        :rows-per-page-items="[10, 25, 50]")
        template(slot="items" slot-scope="props")
          td {{ props.index+1 }}
          td {{ props.item.reportName }}
          td {{ props.item.reportPeriod }}
          td {{ props.item.creationDate }}
          td
            router-link(
            :to="`/edit-report/${props.item.reportKey}/${props.item.statReportId}`") {{$t('ReportingPage.ButtonReporting.editReporting')}}
        template(v-slot:pageText="props").
          {{$t('ReportingPage.PaginationBlock.noteFrom')}} {{ props.pageStart }}
          {{$t('ReportingPage.PaginationBlock.notePo')}} {{ props.pageStop }}
          {{$t('ReportingPage.PaginationBlock.noteFroms')}} {{ props.itemsLength }}
          {{$t('ReportingPage.PaginationBlock.noteEnd')}}
</template>

<script>
import axios from 'axios'
export default {
  name: 'Draft',
  data() {
    return {
      drafts: [],
      draftError: '',
      headers: [
        { text: '№', sortable: false },
        { text: this.$t('ReportingPage.SortForm.nameForm'), sortable: false },
        { text: this.$t('ReportingPage.SortForm.reportingDate'), value: 'reportPeriod', sortable: true },
        { text: this.$t('ReportingPage.SortForm.reportingCreateDate'), sortable: false },
        { text: this.$t('ReportingPage.SortForm.actions'), sortable: false }
      ],
      loading: false
    }
  },
  mounted() {
    this.getDraftsList()
  },
  computed: {
    archiveReports() {
      return this.$store.state.archive.archiveReports
    }
  },
  methods: {
    getDraftsList() {
      this.loading = true
      axios({
        method: 'GET',
        url: '/api/report/GetMyDraftReports'
      })
        .then(response => {
          this.drafts = response.data.result
          this.loading = false
        })
        .catch(error => {
          this.draftError = error.response.data.message
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/MainPage/components/Draft/Draft.vue